<template>
  <fb-form-body>
    <el-form :model="formData"  ref="form" label-width="140px" class="fb-form">

      <el-form-item :label="$t('lang.用户')" prop="userCode">
        <el-select v-model="formData.userCode" :placeholder="$t('lang.请选择')">
          <el-option v-for="i in userList" :key="i.code" :label="i.nickname" :value="i.code"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('lang.评分')" prop="score">
        <el-rate style="height: 40px; display: flex;align-items: center" v-model="formData.score"></el-rate>
      </el-form-item>

      <el-form-item :label="$t('lang.评价内容')">
        <el-input :maxlength="300" show-word-limit type="textarea" v-model="formData.content" :rows="5"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
import {getUserList} from "../../js/common";

export default {
  name: "EvaluationAdd",
  components: {},
  data() {
    return {
      api: {
        add: this.$api.recipeUserEvaluation.add
      },
      formData: {
        userCode: '',
        content: '',
        score: null
      },
      recipeTagList: []
    }

  }
  ,
  computed: {
    userList() {
      return this.$store.state.userList;
    }
  },
  methods: {
    handleSubmit(form) {
      let vm = this;

      if(!vm.formData.score || !vm.formData.content) {
        vm.$message.error(vm.$t('lang.评分或内容不能为空'));
        return;
      }

      vm.$refs[form].validate((valid) => {
        if (valid) {
          let data = {...this.formData};
          data['recipeEditionCode'] = vm.$route.query['recipeEditionCode'];
          data['evaluationTime'] = vm.handleGetTime();

          vm.$http.post(vm.api.add, vm.$qs.stringify(data)).then((resp) => {
            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {

              console.log(vm.$refs[form]);




              if (resp.data.desc) {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }


            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    }
    ,
    handleReset(form) {
      this.$refs[form].resetFields();
      this.formData.content = '';
    },

    handleGetTime() {
      let date = new Date();
      let y = date.getFullYear();
      let M = date.getMonth() + 1;
      let d = date.getDate();
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      if(M < 10) M = '0' + M;
      if(d < 10) d = '0' + d;
      if(h < 10) h = '0' + h;
      if(m < 10) m = '0' + m;
      if(s < 10) s = '0' + s;
      return `${y}-${M}-${d} ${h}:${m}:${s}`;
    }
  }
  ,
  async created() {
    // let vm = this;
    getUserList(this);
  }
}
</script>

<style lang="scss" scoped>

.fb-form {
  max-width: 500px;
}

</style>
